import { LogLevel, type LogLevelConfig } from '@simplisafe/compass-web'
import { LoggerName } from './LoggerName'

export const devLogLevels: LogLevelConfig<typeof LoggerName> = {
  defaultLevel: LogLevel.ERROR,
  namedLoggers: {}
}
